import React, {Component} from 'react';
import {withTranslate} from 'react-redux-multilingual'
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {TbMenu2, TbPhone} from 'react-icons/tb';
import MainMenu from "./common/navbar";
import LogoImage from "./common/logo";
import LanguageSwitchBlock from "./common/language-switch";
import MobileNav from "./common/mobile-nav";
import QuickContact from "./common/quick-contact";
import Modal from 'react-responsive-modal';
import ContactForm from "../contact-form/contact-form";
import contacts from "../../../constants/contacts";
import {SCHEDULE_VISIT_EVENT} from "../../cpr/schedule-visit";
import './header.scss';


class HeaderOne extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            navOpen: false,
        }
    }

    componentDidMount() {
        window.addEventListener(SCHEDULE_VISIT_EVENT, this.onOpenModal);
    }

    componentWillUnmount() {
        window.removeEventListener(SCHEDULE_VISIT_EVENT, this.onOpenModal);
    }

    onOpenModal = (e) => {
        if (e && e.preventDefault && e.type === 'click') {
            e.preventDefault();
        }
        this.setState({open: true, navOpen: false});
    };

    onCloseModal = () => {
        this.setState({open: false});
    };

    closeNav = () => {
        this.setState({navOpen: false});
    };

    render() {
        const {translate, menu} = this.props;
        return (
            <>
                <a className="cpr-skip-link" href="#main">{translate('skip_to_content')}</a>
                <header id="masthead" className="cpr-header">
                    <div className="cpr-container cpr-header__inner">
                        <LogoImage/>
                        <MainMenu menu={menu} location={this.props.location}/>
                        <div className="cpr-header__actions">
                            <a className="cpr-header__phone cpr-num" href={contacts.phone.href}>
                                <TbPhone aria-hidden="true"/>
                                {contacts.phone.display}
                            </a>
                            <LanguageSwitchBlock/>
                            <button type="button" className="cpr-btn cpr-btn--primary cpr-header__cta"
                                    onClick={this.onOpenModal}>{translate('schedule_a_visit')}</button>
                            <button type="button" className="cpr-header__menu-btn"
                                    aria-expanded={this.state.navOpen} aria-controls="cpr-mobile-nav"
                                    onClick={() => this.setState({navOpen: true})}>
                                <TbMenu2 aria-hidden="true"/>
                                <span className="cpr-visually-hidden">{translate('menu')}</span>
                            </button>
                        </div>
                    </div>
                </header>
                <MobileNav id="cpr-mobile-nav" open={this.state.navOpen} menu={menu} location={this.props.location}
                           onClose={this.closeNav}
                           onScheduleVisit={this.onOpenModal}/>
                <QuickContact onScheduleVisit={this.onOpenModal}/>
                <Modal open={this.state.open} onClose={this.onCloseModal} center
                       classNames={{modal: 'cpr-modal', overlay: 'cpr-modal-overlay'}}>
                    <h2 className="cpr-h3 cpr-modal__title">{translate('schedule_a_visit')}</h2>
                    <ContactForm onClose={() => this.setState({open: false})}/>
                </Modal>
            </>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

// withRouter: connect() blocks re-renders, so active nav links need the location passed down.
export default withRouter(connect(mapStateToProps)(withTranslate(HeaderOne)));
